module.exports = __webpack_public_path__ + "img/signal-3.735a56eb.svg";